import { api } from "./api"

export const GET_ALL_CUSTOMERS = async () => {
    const {data} = await api.get(`/customers`)
    return data;
}

export const DELETE_CUSTOMER = async (companyId) => {
    const {data} = await api.delete(`/customers/${companyId}`)
    return data;
}

export const SAVE_CUSTOMER = async (params) => {
    const {data} = await api.post(`/customers`, params)
    return data;
}
